import { Component, HostBinding, inject, input } from '@angular/core';
import { ContextInterface, EduContent, LevelInterface, ResultInterface, StudentInterface } from '@campus/dal';
import { ENVIRONMENT_RESULTS_SHOW_STARS_TOKEN } from '@campus/environment';
import { ConceptWithResultActionsInterface } from '../../interfaces/practice/concept-with-result-actions.interface';
import { ContentActionInterface } from '../../services/content-actions';

export interface HeaderInfoStrandDetailInterface {
  studentDisplayName?: string;
  strandName: string;
  methodName: string;
  logo: string;
  surveyAnswers?: string[];
}

@Component({
  standalone: false,
  selector: 'campus-learning-path',
  templateUrl: './learning-path.component.html',
  styleUrls: ['./learning-path.component.scss'],
})
export class LearningPathComponent {
  @HostBinding('class')
  defaultClasses = ['stack'];

  public showStars = inject(ENVIRONMENT_RESULTS_SHOW_STARS_TOKEN);
  public EduContent = EduContent;

  public concepts = input<ConceptWithResultActionsInterface[]>();
  public headerInfo = input<HeaderInfoStrandDetailInterface>();
  public student = input<StudentInterface>();
  public useLevelIndicator = input<boolean>(false);
  public levels = input<LevelInterface[]>();
  public showHeader = input<boolean>(true);
  public tocId = input<number | undefined>();

  public handleEduContentAction(action: ContentActionInterface, result: ResultInterface) {
    if (!result?.eduContent) return;

    const eduContent = EduContent.toEduContent(result.eduContent);
    const options = { forResult: result };
    const context: ContextInterface = { tocId: this.tocId() };

    action.handler?.(eduContent, options, context);
  }
}
